import React from "react"

import Button from "@irati/ui/src/Button"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import favouritesService from "@irati/deals/services/favourites"
import {Deal} from "@irati/types"
import FormattedMessage from "@irati/utils/lang"
import IsDealFavourited from "@irati/deals/apollo/query/IsDealFavourited"

export type FavouriteButtonOnChange = (isFavourite: boolean, deal: Deal) => any

export interface FavouriteButtonWithIconProps {
  deal: Deal,
  onChange?: FavouriteButtonOnChange,
  iconSize?: number,
  className?: string,
  full?: boolean
}

const FavouriteButton: React.FC<FavouriteButtonWithIconProps> = ({deal, className, iconSize = 20, onChange}) => {
  const onClick = (isFavourite: boolean) => {
    if (onChange) {
      onChange(!isFavourite, deal)
    }

    return isFavourite ? favouritesService.remove(deal) : favouritesService.add(deal)
  }

  const text = (isFavourite: boolean) => {
    if (isFavourite) {
      return <FormattedMessage id="perks.components.importantInfoBlock.favouriteButton.remove" />
    }
    return <FormattedMessage id="perks.components.importantInfoBlock.favouriteButton.save" />
  }

  return (
    <IsDealFavourited dealId={deal.uuid}>
      {({isFavourite}) => (
        <Button tertiary className={className} onClick={() => onClick(isFavourite)}>
          <Icon icon={isFavourite ? IconTypes.favouriteFill : IconTypes.favourite} size={iconSize} marginRight />
          {text(isFavourite)}
        </Button>
      )}
    </IsDealFavourited>
  )
}

export default FavouriteButton
